/**
 * B-604 — applique le REGISTRE PAR DÉFAUT de la vue choisie (métier pour métier/PO/combinée,
 * technique pour développeur/testeur/release manager). N'écrase JAMAIS un choix explicite de la
 * bascule « Détails techniques » (`lib/technical.tsx`). Ne rend rien.
 */
import { useEffect } from 'react'

import { useProfil } from '@/hooks/useProfil'
import { registreParDefaut } from '@/lib/profils'
import { useTechnical } from '@/lib/technical'

export function RegistreSelonProfil(): null {
  const { vue, pret } = useProfil()
  const { appliquerDefaut } = useTechnical()
  useEffect(() => {
    if (pret) appliquerDefaut(registreParDefaut(vue) === 'technique')
  }, [vue, pret, appliquerDefaut])
  return null
}
